import {React} from 'react'
import RoutesFilter from './RoutesFilter'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from 'react-redux';
import DefaultRoutes from './routes/defaultRoutes';

const App = () => {
  const loginuser=useSelector((state)=>state.admin);
  const user=localStorage.getItem('user');
  if(!user) return <DefaultRoutes/>;
  if(user.length>0) return <RoutesFilter/>


  // return (
  //   <>
  //   {loginuser.length>0?<RoutesFilter/>:<AdmnSignIn/>}
  //   </>
  // )
}

export default App